import AccountApp from './AccountApp';
import AccountPage from './views/AccountPage';
// import AccountDetails from './views/AccountDetails';
import AccountEdit from './views/AccountEdit';

export const accountRoutes = [
  {
    path: '/account/:organizationId',
    component: AccountApp,
    children: [
      {
        name: 'AccountPage',
        path: '/',
        component: AccountPage
      },
      {
        name: 'AccountEdit',
        path: 'edit/:id?',
        component: AccountEdit,
        meta: { isModal: true }
      },
      // {
      //   name: 'AccountDetails',
      //   path: ':id',
      //   component: AccountDetails
      // }
    ]
  }
]